export default "__VITE_ASSET__WMYKgYAe__"